module.exports = __webpack_public_path__ + "static/media/22ESCWA17.a9eff154.jpg";